import { styled } from '@mui/material/styles';

export const StyledBlurredAztecCodeWrapper = styled('div')(() => ({
	position: 'relative',
	margin: 'auto',
}));

export const StyledBlurredAztecCodeImg = styled('img')(() => ({
	width: '311px',
	height: '311px',
	maxWidth: '100%',
	maxHeight: '100%',
	display: 'block',
	objectFit: 'contain',
}));

export const StyledOverlayContainer = styled('div')(() => ({
	position: 'absolute',
	top: 0,
	left: 0,
	right: 0,
	bottom: 0,
	backdropFilter: 'blur(1px)',
	backgroundColor: 'rgba(0, 0, 0, 0.6)',
	borderRadius: '0px',
	zIndex: 1,
}));

export const StyledPauseIconWrapper = styled('div')(() => ({
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	filter: 'none !important',
	backdropFilter: 'none !important',
	zIndex: 10,
	pointerEvents: 'none',
}));
